import { ReactNode } from 'react'
import PanelToolbar from './PanelToolbar'

interface PanelProps {
  title: string
  icon?: ReactNode
  children: ReactNode
  isMaximized?: boolean
  onMaximize?: () => void
  onClose?: () => void
  closeable?: boolean
  className?: string
  extra?: ReactNode
  leftExtra?: ReactNode
  /**
   * Hide the panel toolbar (title bar). Used on mobile where outer chrome
   * (TerminalHost, MobileWorkspaceLayout's tab bar) already conveys context
   * and the inner toolbar is just redundant vertical space.
   */
  hideToolbar?: boolean
}

export default function Panel({
  title,
  icon,
  children,
  isMaximized,
  onMaximize,
  onClose,
  closeable = true,
  className = '',
  extra,
  leftExtra,
  hideToolbar = false,
}: PanelProps) {
  return (
    <div className={`flex flex-col h-full bg-card overflow-hidden ${className}`}>
      {!hideToolbar && (
        <PanelToolbar
          title={title}
          icon={icon}
          isMaximized={isMaximized}
          onMaximize={onMaximize}
          onClose={onClose}
          closeable={closeable}
          extra={extra}
          leftExtra={leftExtra}
        />
      )}
      <div className="flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  )
}
